export interface SitePhoto {
  slotKey: string;
  signedUrl: string;
  thumbnailUrl: string | null;
  originalName: string;
  mimeType: string;
  uploadedAt: string;
}

export type SitePhotoMap = Record<string, string>;

interface SitePhotoListResponse {
  data?: SitePhoto[];
}

interface SitePhotoWindow {
  __weddingSitePhotos?: Promise<SitePhotoListResponse>;
}

async function requestSitePhotoList(): Promise<SitePhotoListResponse> {
  const res = await fetch("/media-api/site-photos", { credentials: "include" });
  if (!res.ok) return { data: [] };
  return (await res.json()) as SitePhotoListResponse;
}

/**
 * Fetch all site photos from the media API and return a map of slotKey→signedUrl.
 * Reuses the request started by the page's index.html when that promise exists.
 */
export async function fetchSitePhotos(
  _basePath?: string,
): Promise<SitePhotoMap> {
  try {
    const w = window as unknown as SitePhotoWindow;
    if (!w.__weddingSitePhotos) {
      w.__weddingSitePhotos = requestSitePhotoList().catch(() => ({ data: [] }));
    }
    const json = await w.__weddingSitePhotos;
    const photos: SitePhoto[] = json.data ?? [];
    const map: SitePhotoMap = {};
    for (const p of photos) {
      map[p.slotKey] = p.signedUrl;
    }
    return map;
  } catch {
    return {};
  }
}
